<div class="container">
  <div class="image-container">
    <fa-icon *ngIf="iconName && iconName.length > 0" [icon]="['far', iconName]"></fa-icon>
  </div>
  <a>
    <ng-content></ng-content>
  </a>
</div>
